import BaseService from 'services/BaseService';

//-------------------------------------------------------------------------------------------------------------------

export default class DashboardService
    extends BaseService {

    static async getInstructorSnapshot() {
        return BaseService.callAPI('dashboard/get-instructor-snapshot');
    }

    static async getDevTasksSnapshot() {
        return BaseService.callAPI('dashboard/get-dev-tasks-snapshot');
    }

    static async getBookingTodos() {
        return BaseService.callAPI('dashboard/get-booking-todos');
    }

    static async getVendorBookingTodos() {
        return BaseService.callAPI('dashboard/get-vendor-booking-todos');
    }

    static async getAvailableDates() {
        return BaseService.callAPI('dashboard/get-available-dates');
    }

    static async getInstructorChanges() {
        return BaseService.callAPI('dashboard/get-instructor-changes');
    }

    static async getPerformanceSnapshot({ dateFrom, dateTo }) {
        return BaseService.callAPI('dashboard/get-performance-snapshot', { dateFrom, dateTo });
    }

    static async getRecentlyApprovedEnablements({ language }) {
        return BaseService.callAPI('dashboard/get-recently-approved-enablements', { language });
    }
    
}
